// Shared timing & lifecycle helpers for SVG animations
// Provides a generic stop function and a scheduleNext utility for sporadic animations.

export const stopManagedAnimation = (element, { animatedElements, sporadicTimers } = {}) => {
	if (!element || !animatedElements) return;
	if (sporadicTimers && sporadicTimers.has(element)) {
		clearTimeout(sporadicTimers.get(element));
		sporadicTimers.delete(element);
	}
	const anim = animatedElements.get(element);
	if (anim && typeof anim.kill === "function") anim.kill();
	animatedElements.delete(element);
};

export const scheduleNext = ({
	element,
	animatedElements,
	sporadicTimers,
	startSingleCycle,
	randomDelayMin,
	randomDelayMax,
}) => {
	if (!sporadicTimers || !animatedElements || !element || !startSingleCycle) return;
	const delay = Math.random() * (randomDelayMax - randomDelayMin) + randomDelayMin;
	const id = setTimeout(() => {
		if (!animatedElements.has(element)) return; // stopped meanwhile
		const anim = startSingleCycle();
		animatedElements.set(element, anim);
	}, delay);
	sporadicTimers.set(element, id);
};
